import styled from "styled-components";
import { rgba } from "polished";

export const StyledContainer = styled.div`
  display: flex;
  align-items: flex-start;
  max-width: 300px;
  font-size: 0.875rem;
`;

export const StyledIcon = styled.div`
  padding: 1em;
  line-height: 0;
  border-radius: 50%;
  margin-right: 1em;
  background: ${(props) => rgba(props.background, 0.1)};
`;

export const StyledContent = styled.div``;

export const Title = styled.h3`
  font-weight: normal;
  font-size: 1.25rem;
  margin: 0;
  color: #464646;
`;

export const Description = styled.p`
  color: #888888;
`;

export const Link = styled.a`
  text-decoration: underline;
  color: ${(props) => props.color};
`;
